export const OFFER_SELECTING = 'OFFER_SELECTING';
export const OFFER_SELECTING_PENDING = 'OFFER_SELECTING_PENDING';
export const OFFER_SELECTING_SUCCESS = 'OFFER_SELECTING_SUCCESS';
export const OFFER_SELECTING_FAILURE = 'OFFER_SELECTING_FAILURE';
export const OFFER_SELECTING_RESET = 'OFFER_SELECTING_RESET';
